"use client";
import React from "react";
import { FaLinkedinIn, FaQuoteRight, FaArrowRight } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

import faculties from "../faculty/data/faculties";
import Link from "next/link";

const SwiperSlider = () => {
  return (
    <div className="w-full">
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        autoplay={{ delay: 3500 }}
        pagination={{ clickable: true }}
        modules={[Pagination, Autoplay, EffectCoverflow]}
        className="py-12"
      >
        {faculties.map((faculty) => (
          <SwiperSlide key={faculty.id} className="max-w-[350px] md:max-w-[400px] px-4">
            <div className="faculty-glass-card p-8 h-full flex flex-col relative group border border-slate-100">
              {/* Background Quote */}
              <FaQuoteRight className="absolute top-6 right-8 text-slate-100 text-6xl group-hover:text-blue-50 transition-colors" />

              <div className="relative z-10">
                {/* Image Frame */}
                <div className="relative w-24 h-24 mb-6">
                  <div className="absolute inset-0 bg-blue-600 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-500"></div>
                  <img
                    src={faculty.image}
                    alt={faculty.title}
                    className="absolute inset-0 w-full h-full object-cover rounded-2xl border-4 border-white shadow-sm"
                  />
                </div>

                {/* VISIBLE TEXT COLORS START HERE */}
                <h3 className="text-2xl font-bold text-slate-900 mb-1 group-hover:text-blue-600 transition-colors">
                  {faculty.title}
                </h3>
                <p className="text-blue-500 text-[10px] font-bold uppercase tracking-[0.2em] mb-4">
                  Expert Mentor
                </p>

                <p className="text-slate-600 text-sm leading-relaxed mb-8 line-clamp-3">
                  "{faculty.description}"
                </p>
              </div>

              {/* Bottom Actions */}
              <div className="mt-auto flex items-center justify-between border-t border-slate-100 pt-6">
                {faculty.linkedinUrl && (
                  <Link
                    href={faculty.linkedinUrl}
                    target="_blank"
                    className="flex items-center gap-2 text-slate-500 hover:text-blue-600 transition-colors text-sm font-medium"
                  >
                    <span className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-all">
                      <FaLinkedinIn size={12} />
                    </span>
                    Connect
                  </Link>
                )}
                <FaArrowRight className="text-slate-300 group-hover:text-blue-500 transition-colors" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperSlider;